export enum VirtualRedTagEvaluationType {
    trailerCompany = 'TrailerCompany',
    trailerType = 'TrailerType',
    trailerAttached = 'TrailerAttached',
    trailerStatus = 'TrailerStatus',
    trailerReserved = 'TrailerReserved',
    trailerProximity = 'TrailerProximity',
    evaluationException = 'EvaluationException',
}

export enum VirtualRedTagEvaluationResult {
    pass = 'Pass',
    warn = 'Warn',
    fail = 'Fail',
}

export type VirtualRedTagEligibilityEvaluation = {
    evaluationType: VirtualRedTagEvaluationType;
    result: VirtualRedTagEvaluationResult;
    message: string;
};

export type VirtualRedTagEligibilityResponse = {
    trailerNumber: string;
    trailerCompany: string;
    canRedTag: boolean;
    evaluations: VirtualRedTagEligibilityEvaluation[];
};

export type VirtualRedTagEligibilityRequest = {
    scannedQrId?: string;
    trailerCompositeId?: string;
    driverCompany: string;
    driverId?: string;
    reportedLocation?: { latitude: number; longitude: number };
};
